import gql from 'graphql-tag';

export const VIRTUAL_COMPONENTS_AUTOCOMPLETE_QUERY = gql`
    query virtualComponentsAutocomplete($projectKey: String, $searchText: String, $excludeComponentIds: [String]) {
        virtualComponentsAutocomplete(
            projectKey: $projectKey
            searchText: $searchText
            excludeComponentIds: $excludeComponentIds
        ) {
            id
            name
            projects {
                jiraProjectName
                jiraComponentId
                jiraProjectKey
            }
        }
    }
`;

export const EXPORT_VIRTUAL_COMPONENTS_QUERY = gql`
    query findAllVirtualComponents($filter: VirtualComponentsFilter, $sorting: Sorting) {
        findAllVirtualComponents(filter: $filter, sorting: $sorting) {
            id
            name
            description
            assigneeType
            virtualComponentLead {
                jiraUserDisplayName
            }
            projects {
                jiraProjectName
            }
        }
    }
`;

export const VIRTUAL_COMPONENTS_QUERY_PAGINATED = gql`
    query virtualComponentsPaginated($filter: VirtualComponentsFilter, $sorting: Sorting, $pagination: Pagination) {
        virtualComponentsPaginated(filter: $filter, sorting: $sorting, pagination: $pagination) {
            count
            rows {
                id
                name
                description
                assigneeType
                virtualComponentLead {
                    jiraUserAccountId
                }
                projects {
                    style
                    jiraComponentId
                    jiraProjectId
                    jiraProjectKey
                    jiraProjectName
                    jiraAvatarUrls {
                        xsmall
                        large
                    }
                }
            }
        }
    }
`;
export const VIRTUAL_COMPONENT_RELEASES_AUTO_COMPLETE_QUERY = gql`
    query virtualComponentReleasesPaginated(
        $filter: VirtualComponentReleasesFilter
        $sorting: Sorting
        $pagination: VersionsPagination
    ) {
        virtualComponentReleasesPaginated(filter: $filter, sorting: $sorting, pagination: $pagination) {
            rows {
                id
                name
                customFieldOptionId
                releasedCustomFieldOptionId
                isReleased
                componentName
            }
        }
    }
`;

export const VIRTUAL_COMPONENT_RELEASES_QUERY_PAGINATED = gql`
    query virtualComponentReleasesPaginated(
        $filter: VirtualComponentReleasesFilter
        $sorting: Sorting
        $pagination: VersionsPagination
    ) {
        virtualComponentReleasesPaginated(filter: $filter, sorting: $sorting, pagination: $pagination) {
            count
            rows {
                id
                name
                description
                startDate
                virtualComponent {
                    id
                    name
                    projects {
                        id
                        jiraProjectId
                        jiraProjectKey
                        jiraProjectName
                    }
                }
                selectedProjectVersions {
                    jiraProjectId
                    jiraProjectVersionId
                }
                releaseDate
                isReleased
                isDeleted
            }
        }
    }
`;

export const VIRTUAL_COMPONENTS_HIERARCHY_QUERY_PAGINATED = gql`
    query virtualComponentsHierarchyPaginated(
        $filter: VirtualComponentsFilter
        $sorting: Sorting
        $pagination: Pagination
    ) {
        virtualComponentsHierarchyPaginated(filter: $filter, sorting: $sorting, pagination: $pagination) {
            count
            components {
                id
                name
                description
                assigneeType
                parentId
                parents {
                    id
                    name
                }
                hasChildren
                virtualComponentLead {
                    jiraUserAccountId
                    jiraUserDisplayName
                    jiraUserAvatarUrl
                }
                projects {
                    id
                    style
                    jiraComponentId
                    jiraProjectId
                    jiraProjectKey
                    jiraProjectName
                    jiraAvatarUrls {
                        xsmall
                        large
                    }
                    style
                }
                virtualLabels {
                    id
                    name
                    parentId
                }
            }
            labels {
                id
                name
                parentId
                hasChildren
            }
        }
    }
`;

export const VIRTUAL_COMPONENTS_HIERARCHY_CHILDREN = gql`
    query virtualComponentsHierarchyChildren($componentId: String) {
        virtualComponentsHierarchyChildren(componentId: $componentId) {
            id
            name
            description
            assigneeType
            parentId
            parents {
                id
                name
            }
            hasChildren
            virtualComponentLead {
                jiraUserAccountId
                jiraUserDisplayName
                jiraUserAvatarUrl
            }
            projects {
                id
                style
                jiraComponentId
                jiraProjectId
                jiraProjectKey
                jiraProjectName
                jiraAvatarUrls {
                    xsmall
                    large
                }
                style
            }
            virtualLabels {
                id
                name
                parentId
            }
        }
    }
`;
export const VIRTUAL_LABELS_CHILDREN = gql`
    query virtualLabelsChildren($labelId: String) {
        virtualLabelsChildren(labelId: $labelId) {
            components {
                id
                name
                description
                assigneeType
                parentId
                hasChildren
                virtualComponentLead {
                    jiraUserAccountId
                    jiraUserDisplayName
                    jiraUserAvatarUrl
                }
                projects {
                    id
                    style
                    jiraComponentId
                    jiraProjectId
                    jiraProjectKey
                    jiraProjectName
                    jiraAvatarUrls {
                        xsmall
                        large
                    }
                    style
                }
                virtualLabels {
                    id
                    name
                    parentId
                }
            }
            labels {
                id
                name
                parentId
                hasChildren
            }
        }
    }
`;

export const VIRTUAL_COMPONENT_QUERY = gql`
    query virtualComponent($id: String) {
        virtualComponent(id: $id) {
            id
            name
            description
            assigneeType
            parentId
            parents {
                id
                name
            }
            virtualComponentLead {
                jiraUserAccountId
            }
            projects {
                id
                style
                jiraComponentId
                jiraProjectId
                jiraProjectKey
                jiraProjectName
                jiraAvatarUrls {
                    xsmall
                    large
                }
            }
            virtualLabels {
                id
                name
            }
        }
    }
`;

export const VIRTUAL_COMPONENT_RELEASES_QUERY = gql`
    query virtualComponentReleases($projectKey: String) {
        virtualComponentReleases(projectKey: $projectKey) {
            id
            name
            description
            startDate
            virtualComponent {
                id
                name
                projects {
                    id
                    jiraProjectId
                    jiraProjectKey
                    jiraProjectName
                }
            }
            selectedProjectVersions {
                jiraProjectId
                jiraProjectVersionId
            }
            releaseDate
            isReleased
            isDeleted
        }
    }
`;

export const VIRTUAL_COMPONENT_RELEASE_WITH_JIRA_PROJECT_VERSIONS_QUERY = gql`
    query virtualComponentReleaseWithJiraProjectVersions($id: String) {
        virtualComponentReleaseWithJiraProjectVersions(id: $id) {
            id
            name
            description
            startDate
            virtualComponentId
            virtualComponent {
                id
                name
                projects {
                    id
                    jiraProjectId
                    jiraProjectName
                }
            }
            selectedProjectVersions {
                jiraProjectId
                jiraProjectVersionId
            }
            jiraProjectVersions {
                id
                self
                name
                description
                archived
                released
                projectId
                issuesStatusForFixVersion {
                    unmapped
                    toDo
                    inProgress
                    done
                }
            }
            releaseDate
            isReleased
            isDeleted
        }
    }
`;

export const JIRA_PROJECTS_QUERY = gql`
    query jiraProjects {
        jiraProjects {
            key
            id
            name
            style
            jiraAvatarUrls {
                xsmall
                large
            }
        }
    }
`;

export const VIRTUAL_LABELS_QUERY_PAGINATED = gql`
    query virtualLabelsPaginated($filter: VirtualLabelsFilter, $sorting: Sorting, $pagination: Pagination) {
        virtualLabelsPaginated(filter: $filter, sorting: $sorting, pagination: $pagination) {
            id
            name
            parentId
        }
    }
`;

export const JIRA_ISSUE = gql`
    query jiraIssue($id: String, $includeVirtualComponentIds: Boolean) {
        jiraIssue(id: $id, includeVirtualComponentIds: $includeVirtualComponentIds) {
            id
            key
            fields {
                components {
                    id
                    name
                    virtualComponentId
                }
            }
            customFields
        }
    }
`;

export const HAS_ACCESS_COMPONENT_VERSIONS_CUSTOM_FIELDS = gql`
    query hasAccessComponentVersionsCustomFields($id: String) {
        hasAccessComponentVersionsCustomFields(id: $id) {
            hasAccess
        }
    }
`;

export const JIRA_ISSUE_LINK_COMPONENTS_VERSIONS = gql`
    query jiraIssueWithComponentVersions($id: String) {
        jiraIssueWithComponentVersions(id: $id) {
            id
            name
        }
    }
`;

export const VIRTUAL_COMPONENT_ISSUES_COUNT = gql`
    query virtualComponentIssuesCount($componentsIds: [String]) {
        virtualComponentIssuesCount(componentsIds: $componentsIds) {
            issuesCount
        }
    }
`;

export const SYNC_ERRORS = gql`
    query syncErrors {
        syncErrors {
            id
            type
            title
            message
            virtualComponentId
            acknowledged
        }
    }
`;

export const SYNC_DATA = gql`
    query syncData {
        syncData {
            val {
                date
            }
        }
    }
`;

export const LICENSE_STATE_QUERY = gql`
    query licenseState {
        licenseState {
            licenseId
        }
    }
`;

export const HISTORY_LOGS = gql`
    query historyLogs($objectType: String, $objectId: String) {
        historyLogs(objectType: $objectType, objectId: $objectId) {
            id
            changeType
            changeValue
            oldValue
            createdAt
            user {
                displayName
                avatar
            }
        }
    }
`;

export const VIRTUAL_LABELS_QUERY = gql`
    query virtualLabels {
        virtualLabels {
            id
            name
            jiraProjectId {
                id
                name
            }
        }
    }
`;

export const JIRA_PROJECT_ID_QUERY = gql`
    query jiraProjectIds {
        jiraProjectIds {
            id
            name
            project {
                id
                key
                name
            }
            virtualLabels {
                id
                name
            }
        }
    }
`;

export const IMPORT_COMPONENTS_AND_SYNCHRONIZE_PROCESS_QUERY = gql`
    query getImportComponentsProcessAndGetSynchronizeComponentsProcess {
        getImportComponentsProcess {
            processType
            active
        }
        getSynchronizeComponentsProcess {
            processType
            active
        }
    }
`;
export const PROJECT_IS_ENABLED = gql`
    query projectIsEnabled($projectId: Int) {
        projectIsEnabled(projectId: $projectId) {
            status
        }
    }
`;

export const GET_PERMISSIONS = gql`
    query getPermissions {
        getPermissions {
            havePermission
            key
        }
    }
`;
